var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('MaterialsHeader'),(_vm.$route.name === 'Materials')?_c('Materials'):_c('MyMaterials')],1)}
var staticRenderFns = []

export { render, staticRenderFns }